import { createFileRoute } from "@tanstack/react-router";

import { api } from "~/lib/api";

export const Route = createFileRoute("/_main/bookings/_layout/")({
  component: Bookings,
});

function Bookings() {
  const utils = api.useUtils();
  void utils.booking.getAll.invalidate();

  return null;
}
